import { render, staticRenderFns } from "./NotificationToggle.vue?vue&type=template&id=9290108a&scoped=true"
import script from "./NotificationToggle.vue?vue&type=script&lang=js"
export * from "./NotificationToggle.vue?vue&type=script&lang=js"
import style0 from "./NotificationToggle.vue?vue&type=style&index=0&id=9290108a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9290108a",
  null
  
)

export default component.exports